import React, { useEffect, useState } from "react";
import useMutation from "../../../../../hooks/useMutation";
import { scholarShipApply } from "../../../../../services/applicationFormService";
import { toast } from "react-toastify";
import Button from "../../../../form/Button";
import DynamicField from "../../../../form/DynamicField";
import useForm from "../../../../../hooks/useForm";

const SupportingDocFormFront = ({
  continueHandler = () => {},
  backHandler = () => {},
  close = () => {},
  data,
  details,
  loaded,
  setLoaded = () => {},
  scholarshipId,
}) => {
  const [fieldConfigs, setFieldConfigs] = useState([]);
  useEffect(() => {
    if (data) {
      setLoaded(true);

      const updatedFields =
        data?.data?.map((item, index) => ({
          ...item,
          name: item.name || `field_${index}`,
          type: item?.type || "",
          label: item?.label || "",
          placeholder: item?.placeholder || "",
          isRequired: item?.isRequired || false,
        })) || [];

      const initialValues = {};
      updatedFields?.forEach((field) => {
        initialValues[field.name] = field?.fieldValue ?? "";
      });

      setFieldConfigs(updatedFields);
      setFieldsValue(initialValues);
      setLoaded(false);
    }
  }, [data]);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    validationRules: Object.assign(
      {},
      ...fieldConfigs?.map((item) => {
        const rules = [];

        if (item?.isRequired) {
          rules.push({
            required: true,
            message: `${item?.label} is required`,
          });
        }

        if (item?.type?.toLowerCase() === "email") {
          rules.push({
            type: "email",
            message: `${item?.label} must be a valid email address`,
          });
        }

        return {
          [item?.name]: rules,
        };
      })
    ),
  });
  const areAnyRequiredFieldsEmpty = fieldConfigs.some(
    (field) => field?.isRequired && !values?.[field.name]
  );
  const { mutate, error, isLoading } = useMutation({
    mutationFn: async (val) => {
      setLoaded(true);
      const structuredData = fieldConfigs?.map((field) => ({
        fieldId: field._id || field.id,
        label: field.label,
        value: values?.[field.name] || "",
      }));
      return await scholarShipApply({
        groupCodeData: structuredData,
        scholarshipId: scholarshipId,
        groupCode: data?._id,
        formId: details?.applicationFormId,
        type: val?.type,
      });
    },
    onSuccess: (res) => {
      setLoaded(false);
      if (res?.isFormSubmitted) {
        toast.success("Application Submitted Successfully!");
        close();
      } else if (res?.type === "save") {
        toast.success("Progress saved successfully!");
        close();
      } else {
        toast.success(res?.message);
        continueHandler();
      }
    },
    onError: (error) => {
      toast.error("Submission failed");
      setLoaded(false);
      console.error("❌ Error during submission:", error);
    },
  });
  // const saveAndResume = () => {
  //   console.log("📝 Saving form for later:", values);
  //   toast.success("Form progress saved!");
  // };
  return (
    <>
      {loaded ? (
        <div className="text-center font-semibold">Loading...</div>
      ) : (
        <form onSubmit={(event) => handleSubmit(event, mutate)}>
          <div className="flex flex-col gap-4">
            {fieldConfigs?.map((f, i) => (
              <DynamicField
                key={i}
                type={f.type?.toLowerCase()}
                name={f.name}
                label={f.label}
                placeholder={f.placeholder}
                value={values?.[f.name] || ""}
                dropdownData={f.options || []}
                onChange={handleChange}
                uploadFile={f.uploadFile}
                uploadButtonText={f.uploadButtonText}
                {...formValidate(errors, f.name)}
              />
            ))}
          </div>

          <div className="my-6 md:mt-12 flex sm:flex-row justify-center gap-2 md:gap-4">
            <Button
              buttonType="button"
              buttonLabel="Back"
              buttonClasses="!rounded-full !px-5 md:!px-8 md:!h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto !text-xs md:!text-lg xl:text-xl"
              buttonFunction={backHandler}
            />
            <Button
              buttonType="submit"
              buttonLabel="Continue"
              buttonClasses="!rounded-full !px-5 md:!px-8 md:!h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto !text-xs md:!text-lg xl:text-xl"
              isDisable={loaded}
            />
            <Button
              buttonType={areAnyRequiredFieldsEmpty ? "submit" : "button"}
              buttonLabel="Save & Resume Later"
              buttonClasses="!rounded-full !px-5 md:!px-8 md:!h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto !text-xs md:!text-lg xl:text-xl"
              isDisable={loaded}
              buttonFunction={() => {
                if (areAnyRequiredFieldsEmpty) {
                  toast.error("Please fill all required fields before saving.");
                  return;
                }

                mutate({ ...values, type: "save" });
              }}
            />
          </div>
        </form>
      )}
    </>
  );
};

export default SupportingDocFormFront;
